import { getIndex } from '@apia/util';
import { getDomProps, getDomStoreProps } from '../store/selection/useDomProps';
import { TResponsiveTableState } from '../store/types';
import { IRequiredDomProps } from '../store/selection/types';

function setAriaAttributes(
  element: HTMLElement,
  attribute: string,
  value: any,
) {
  element.setAttribute(attribute, value as string);
}

function getRowDomProps(rowIndex: number, state: TResponsiveTableState) {
  const elementType: keyof IRequiredDomProps = getIndex(
    ['headerTr', 'filtersTr', 'tr'],
    [
      rowIndex == -2 || (!state.hasNonAdditionalFilters && rowIndex == -1),
      rowIndex == -1,
      true,
    ],
  );

  return getDomProps(
    getDomStoreProps(
      elementType,
      {
        rowIndex,
      },
      () => state,
    ),
    elementType,
    { rowIndex },
  );
}

function applyRowSelectionAttributes(
  row: HTMLElement,
  state: TResponsiveTableState,
) {
  if (!(row instanceof HTMLElement)) return;

  const rowIndex = Number.parseInt(row.dataset.rowindex || 'a', 10);
  const props = getRowDomProps(rowIndex, state);

  Object.entries(props).forEach(([key, value]) => {
    let match: RegExpMatchArray | null;
    match = key.match(/aria-(\w+)/);
    if (match) {
      setAriaAttributes(row, key, value);
    } else if ((match = key.match(/data-(\w+)/))) {
      row.dataset[match[1]] = value as string;
    }
  });
}

export function applySelectionAttributes(
  table: HTMLElement,
  _previousState: TResponsiveTableState,
  state: TResponsiveTableState,
) {
  const previousSelectedRows = table.querySelectorAll<HTMLElement>(
    '[aria-selected="true"]',
  );
  previousSelectedRows.forEach((c) => applyRowSelectionAttributes(c, state));

  if (state.selectedRows.length) {
    const newSelectedRows = table.querySelectorAll<HTMLElement>(
      state.selectedRows
        .map((index) => `tr[data-rowindex="${index}"]`)
        .join(','),
    );
    newSelectedRows.forEach((c) => applyRowSelectionAttributes(c, state));
  }
}
